export default __webpack_public_path__ + "static/media/tribet_receipt.012b8e5e.jpg";